import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MinimizeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"minimize"}/>
}
